import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e78eb924"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-layout" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card card-flex card-outline card-themes" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "btn-group" }
const _hoisted_7 = { class: "card-tools" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("全局搜索")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消搜索")
const _hoisted_10 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("搜索工号")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("搜索姓名")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("搜索手机")
const _hoisted_16 = { class: "btn-group float-right mr-2 hidden-xs" }
const _hoisted_17 = { class: "card-body table-responsive p-0" }
const _hoisted_18 = {
  key: 0,
  class: "table table-striped table-head-fixed table-width-auto text-nowrap text-center"
}
const _hoisted_19 = { ref: "tableTr" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "id" }, "ID", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "操作", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "userStatus" }, "状态", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "userCode" }, "工号", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "userCodeZdd" }, "智多多工号", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "userName" }, "用户名", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "realName" }, "真实姓名", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "userPhone" }, "手机号码", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "roleIdListName" }, "用户角色", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "userDdOpenId" }, "钉钉ID", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "userWxMiniOpenId" }, "小程序ID", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "userWxMpOpenId" }, "公众号ID", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  field: "userIcon",
  class: "normal-width text-left"
}, "用户图标", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "createName" }, "创建姓名", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "createTime" }, "创建时间", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "modifyName" }, "修改姓名", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "modifyTime" }, "修改时间", -1))
const _hoisted_37 = { key: 0 }
const _hoisted_38 = ["colspan"]
const _hoisted_39 = /*#__PURE__*/_createTextVNode("暂无数据")
const _hoisted_40 = { class: "table-btn-group" }
const _hoisted_41 = { class: "btn-group" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { key: 2 }
const _hoisted_47 = { class: "text-left" }
const _hoisted_48 = {
  key: 0,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}
const _hoisted_49 = { class: "content-modal" }
const _hoisted_50 = { class: "row" }

export function render(_ctx, _cache) {
  const _component_app_content_header = _resolveComponent("app-content-header")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_app_dropdown_search = _resolveComponent("app-dropdown-search")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_app_button_tooltip = _resolveComponent("app-button-tooltip")
  const _component_app_table_page = _resolveComponent("app-table-page")
  const _component_app_alert = _resolveComponent("app-alert")
  const _component_app_select_level = _resolveComponent("app-select-level")
  const _component_app_select_dept = _resolveComponent("app-select-dept")
  const _component_app_select_role = _resolveComponent("app-select-role")
  const _component_app_select_from_db = _resolveComponent("app-select-from-db")
  const _component_app_input = _resolveComponent("app-input")
  const _component_app_switch_number = _resolveComponent("app-switch-number")
  const _component_app_modal = _resolveComponent("app-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_content_header),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.Auth('/system/user/add'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-themes",
                    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.addModalOpen && _ctx.addModalOpen(...args)))
                  }, [
                    _createVNode(_component_svg_icon, { name: "add" })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.Auth('/system/user/levelSelect'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-themes",
                    onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.orgCodeLevelModalOpen && _ctx.orgCodeLevelModalOpen(...args)))
                  }, [
                    _createVNode(_component_svg_icon, { name: "list-outline" })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.Auth('/system/user/list'))
                ? (_openBlock(), _createBlock(_component_app_dropdown_search, {
                    key: 0,
                    ref: "tableSearch",
                    modelValue: _ctx.tableRequestItem.searchKey,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.tableRequestItem.searchKey) = $event)),
                    searchFunction: _ctx.searchFunction,
                    disabledTableExport: !_ctx.Auth('/system/user/export')
                  }, {
                    "dropdown-search-menu": _withCtx(() => [
                      _createElementVNode("li", {
                        class: "dropdown-item hyper-text-themes hand",
                        onClick: _cache[2] || (_cache[2] = $event => (_ctx.searchFunction('all')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-sharp",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_8
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[3] || (_cache[3] = $event => (_ctx.searchCancel()))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_9
                      ]),
                      (_ctx.tableRequestItem.lockItem)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.tableRequestItem.lockItem, (item, key, i) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                              (i===0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                                : _createCommentVNode("", true),
                              _createElementVNode("li", {
                                class: _normalizeClass([item.value?'hyper-text-themes':'', "dropdown-item hand"]),
                                onClick: item.openFn
                              }, [
                                _createVNode(_component_svg_icon, {
                                  name: item.value?'radio-button-on':'radio-button-off',
                                  class: "mt-0 mr-1"
                                }, null, 8, ["name"]),
                                _createTextVNode(" " + _toDisplayString(item.title), 1)
                              ], 10, _hoisted_11)
                            ], 64))
                          }), 128))
                        : _createCommentVNode("", true),
                      _hoisted_12,
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[4] || (_cache[4] = $event => (_ctx.searchFunction('user_code')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_13
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[5] || (_cache[5] = $event => (_ctx.searchFunction('real_name')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_14
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[6] || (_cache[6] = $event => (_ctx.searchFunction('user_phone')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_15
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "searchFunction", "disabledTableExport"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.tableRequestItem.dateTime,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.tableRequestItem.dateTime) = $event)),
                type: "datetimerange",
                shortcuts: _ctx.dateTimeShortcuts,
                size: "large",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                style: {"height":"calc(2.25rem + 2px)"},
                onChange: _cache[9] || (_cache[9] = $event => (_ctx.searchFunction('search')))
              }, null, 8, ["modelValue", "shortcuts"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_ctx.Auth('/system/user/list'))
              ? (_openBlock(), _createElementBlock("table", _hoisted_18, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_19, [
                      _hoisted_20,
                      _hoisted_21,
                      _hoisted_22,
                      _createElementVNode("th", {
                        field: "orgTypeIdName",
                        class: "table-search-lock hand active",
                        onClick: _cache[10] || (_cache[10] = (...args) => (_ctx.orgTypeIdLevelModalOpen && _ctx.orgTypeIdLevelModalOpen(...args)))
                      }, "组织类型"),
                      _createElementVNode("th", {
                        field: "orgCodeName",
                        class: "table-search-lock hand active",
                        onClick: _cache[11] || (_cache[11] = (...args) => (_ctx.orgCodeLevelModalOpen && _ctx.orgCodeLevelModalOpen(...args)))
                      }, "所属组织"),
                      _createElementVNode("th", {
                        field: "deptIdName",
                        class: "table-search-lock hand active",
                        onClick: _cache[12] || (_cache[12] = (...args) => (_ctx.deptIdLevelModalOpen && _ctx.deptIdLevelModalOpen(...args)))
                      }, "所属部门"),
                      _createElementVNode("th", {
                        field: "postIdName",
                        class: "table-search-lock hand active",
                        onClick: _cache[13] || (_cache[13] = (...args) => (_ctx.postIdLevelModalOpen && _ctx.postIdLevelModalOpen(...args)))
                      }, "所在岗位"),
                      _hoisted_23,
                      _hoisted_24,
                      _hoisted_25,
                      _hoisted_26,
                      _hoisted_27,
                      _hoisted_28,
                      _hoisted_29,
                      _hoisted_30,
                      _hoisted_31,
                      _hoisted_32,
                      _hoisted_33,
                      _hoisted_34,
                      _hoisted_35,
                      _hoisted_36
                    ], 512)
                  ]),
                  _createElementVNode("tbody", null, [
                    (_ctx.tableItems.length<1)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [
                          _createElementVNode("td", {
                            colspan: _ctx.getTableTrLength(_ctx.$refs.tableTr)
                          }, [
                            _createVNode(_component_svg_icon, { name: "alert" }),
                            _hoisted_39
                          ], 8, _hoisted_38)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableItems, (item, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.userCode,
                        class: _normalizeClass({'text-red': parseInt(item.userStatus)===2})
                      }, [
                        _createElementVNode("td", null, _toDisplayString(((_ctx.tablePageItems.current-1) * _ctx.tablePageItems.size) + i + 1), 1),
                        _createElementVNode("td", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            (_ctx.Auth('/system/user/mod'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "btn btn-themes",
                                  onClick: $event => (_ctx.modModalOpen(item))
                                }, [
                                  _createVNode(_component_svg_icon, { name: "settings-outline" })
                                ], 8, _hoisted_42))
                              : _createCommentVNode("", true),
                            (_ctx.Auth('/system/user/del'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  class: "btn btn-themes",
                                  onClick: $event => (_ctx.delAlert(item))
                                }, [
                                  _createVNode(_component_svg_icon, { name: "trash-outline" })
                                ], 8, _hoisted_43))
                              : _createCommentVNode("", true),
                            (_ctx.Auth('/system/user/roleSelect'))
                              ? (_openBlock(), _createBlock(_component_app_button_tooltip, {
                                  key: 2,
                                  content: "用户配置",
                                  onBtnClick: $event => (_ctx.roleSelectOpen(item))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_icon, { name: "funnel-outline" })
                                  ]),
                                  _: 2
                                }, 1032, ["onBtnClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (parseInt(item.userStatus)===1)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 0,
                              class: "hand",
                              onClick: $event => (_ctx.toggleStatus(item))
                            }, [
                              _createVNode(_component_svg_icon, {
                                name: "checkmark-circle-outline",
                                class: "hyper-text-themes"
                              })
                            ], 8, _hoisted_44))
                          : (parseInt(item.userStatus)===2)
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 1,
                                class: "hand",
                                onClick: $event => (_ctx.toggleStatus(item))
                              }, [
                                _createVNode(_component_svg_icon, {
                                  name: "close-circle-outline",
                                  class: "text-red"
                                })
                              ], 8, _hoisted_45))
                            : (_openBlock(), _createElementBlock("td", _hoisted_46, "未知")),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.orgTypeId.value? 'active' : ''])
                        }, _toDisplayString(item.orgTypeIdName), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.orgCode.value? 'active' : ''])
                        }, _toDisplayString(item.orgCodeName), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.deptId.value? 'active' : ''])
                        }, _toDisplayString(item.deptIdName), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.postId.value? 'active' : ''])
                        }, _toDisplayString(item.postIdName), 3),
                        _createElementVNode("td", null, _toDisplayString(item.userCode), 1),
                        _createElementVNode("td", null, _toDisplayString(item.userCodeZdd), 1),
                        _createElementVNode("td", null, _toDisplayString(item.userName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.realName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.userPhone), 1),
                        _createElementVNode("td", null, _toDisplayString(item.roleIdListName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.userDdOpenId), 1),
                        _createElementVNode("td", null, _toDisplayString(item.userWxMiniOpenId), 1),
                        _createElementVNode("td", null, _toDisplayString(item.userWxMpOpenId), 1),
                        _createElementVNode("td", _hoisted_47, _toDisplayString(item.userIcon), 1),
                        _createElementVNode("td", null, _toDisplayString(item.createName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.createTime), 1),
                        _createElementVNode("td", null, _toDisplayString(item.modifyName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.modifyTime), 1)
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_app_table_page, {
            class: "card-footer",
            pageItems: _ctx.tablePageItems,
            pageFunction: _ctx.getList
          }, null, 8, ["pageItems", "pageFunction"]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _createVNode(_component_svg_icon, {
                  name: "ali-loading",
                  size: "xl",
                  class: "turn"
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_49, [
      _createVNode(_component_app_alert, { ref: "delModal" }, null, 512),
      _createVNode(_component_app_select_level, {
        ref: "orgTypeIdLevel",
        levelType: "select",
        levelApi: _ctx.getOrgTypeAPI,
        selectItem: _ctx.tableRequestItem.lockItem.orgTypeId,
        maxParentId: null,
        selectFunction: _ctx.orgTypeIdLevelFunction,
        searchFieldList: _ctx.orgTypeIdLevelSearchField
      }, null, 8, ["levelApi", "selectItem", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_select_level, {
        ref: "orgCodeLevel",
        levelType: "select",
        levelApi: _ctx.getOrgApi,
        selectItem: _ctx.tableRequestItem.lockItem.orgCode,
        maxParentId: _ctx.authUser.orgCode,
        selectFunction: _ctx.orgCodeLevelFunction,
        searchFieldList: _ctx.orgCodeLevelSearchField
      }, null, 8, ["levelApi", "selectItem", "maxParentId", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_select_dept, {
        ref: "deptIdLevel",
        levelType: "select",
        maxParentId: 'O' + _ctx.authUser.orgParentCode + 'D-1',
        selectItem: _ctx.tableRequestItem.lockItem.deptId,
        selectFunction: _ctx.deptIdLevelFunction,
        searchFieldList: _ctx.deptIdLevelSearchField
      }, null, 8, ["maxParentId", "selectItem", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_select_level, {
        ref: "postIdLevel",
        levelType: "select",
        levelApi: _ctx.getPostApi,
        selectItem: _ctx.tableRequestItem.lockItem.postId,
        maxParentId: null,
        selectFunction: _ctx.postIdLevelFunction,
        searchFieldList: _ctx.postIdLevelSearchField
      }, null, 8, ["levelApi", "selectItem", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_select_role, {
        ref: "roleSelectModal",
        modelValue: _ctx.editRoleList,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.editRoleList) = $event)),
        title: _ctx.editRoleTitle,
        submitFunction: _ctx.roleSelectSubmit
      }, null, 8, ["modelValue", "title", "submitFunction"]),
      _createVNode(_component_app_modal, {
        ref: "editModal",
        title: _ctx.editModalTitle,
        submitButtonName: _ctx.editModalSubmitButtonName,
        size: "lg",
        submitFunction: _ctx.editModalSubmit,
        submitAfterClose: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_50, [
            _createVNode(_component_app_select_from_db, {
              class: "col-lg-6",
              label: "组织类型",
              modelValue: _ctx.editModalItem.orgTypeId,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ((_ctx.editModalItem.orgTypeId) = $event)),
              searchApi: _ctx.orgTypeIdSelectApi
            }, null, 8, ["modelValue", "searchApi"]),
            _createVNode(_component_app_select_from_db, {
              class: "col-lg-6",
              label: "所属组织",
              modelValue: _ctx.editModalItem.orgCode,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((_ctx.editModalItem.orgCode) = $event)),
              searchApi: _ctx.orgCodeSelectApi
            }, null, 8, ["modelValue", "searchApi"]),
            _createVNode(_component_app_input, {
              class: "col-lg-6",
              label: "钉钉ID",
              disabled: "",
              modelValue: _ctx.editModalItem.userDdOpenId,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => ((_ctx.editModalItem.userDdOpenId) = $event)),
              buttonText: "获取钉钉ID",
              onButtonSubmit: _cache[18] || (_cache[18] = $event => (_ctx.getDingID(_ctx.editModalItem.userCode, _ctx.editModalItem.deptId)))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_select_from_db, {
              class: "col-lg-6",
              label: "所属部门",
              modelValue: _ctx.editModalItem.deptId,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => ((_ctx.editModalItem.deptId) = $event)),
              searchApi: _ctx.deptIdSelectApi
            }, null, 8, ["modelValue", "searchApi"]),
            _createVNode(_component_app_select_from_db, {
              class: "col-lg-4",
              label: "所在岗位",
              modelValue: _ctx.editModalItem.postId,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => ((_ctx.editModalItem.postId) = $event)),
              searchApi: _ctx.postIdSelectApi
            }, null, 8, ["modelValue", "searchApi"]),
            _createVNode(_component_app_input, {
              class: "col-lg-4",
              label: "工号",
              modelValue: _ctx.editModalItem.userCode,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => ((_ctx.editModalItem.userCode) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-4",
              label: "真实姓名",
              modelValue: _ctx.editModalItem.realName,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => ((_ctx.editModalItem.realName) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-4",
              label: "手机号码",
              modelValue: _ctx.editModalItem.userPhone,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => ((_ctx.editModalItem.userPhone) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-4",
              label: "用户名",
              modelValue: _ctx.editModalItem.userName,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => ((_ctx.editModalItem.userName) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              type: "password",
              class: "col-lg-4",
              label: "密码(留空则不修改)",
              modelValue: _ctx.editModalItem.userPass,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => ((_ctx.editModalItem.userPass) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-6",
              label: "用户智多多工号",
              modelValue: _ctx.editModalItem.userCodeZdd,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => ((_ctx.editModalItem.userCodeZdd) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-6",
              label: "用户图标",
              modelValue: _ctx.editModalItem.userIcon,
              "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => ((_ctx.editModalItem.userIcon) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_switch_number, {
              class: "col-lg-12",
              label: "状态",
              modelValue: _ctx.editModalItem.userStatus,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => ((_ctx.editModalItem.userStatus) = $event)),
              enableName: "启用",
              disabledName: "禁用"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["title", "submitButtonName", "submitFunction"])
    ])
  ]))
}